import { AfterViewInit, Component, ElementRef, EventEmitter, OnDestroy, OnInit, Signal, viewChild } from '@angular/core';
import { AlertButton } from '@shared/alert/alertButton';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { MessageType } from './alert.helper';
import { TranslationParams } from '../manager/locale-resource.manager';
import { HtmlUtils } from '../util/html-utils';

@Component({
  standalone: false,
  selector: 'app-alert',
  templateUrl: './alert.component.html',
})
export class AlertComponent implements OnInit, AfterViewInit, OnDestroy {

  // -- Modal Inputs --
  public titleClass: string = '';
  public title: string = "";
  public message: string = "";
  public translationParams: TranslationParams | undefined;
  public escapeTranslationParams: boolean = true;
  public iconClass: MessageType = "info";
  public buttonFlags: number[] = [AlertButton.OK];
  public yesButtonLabel: string = 'global.label.yes';
  public noButtonLabel: string = 'global.label.no';
  public nextButtonLabel: string = 'global.label.next';
  // ----

  public finish = new EventEmitter<AlertButton>();

  private okButtonRef: Signal<ElementRef | undefined> = viewChild('okButton');
  private yesButtonRef: Signal<ElementRef | undefined> = viewChild('yesButton');
  private noButtonRef: Signal<ElementRef | undefined> = viewChild('noButton');
  private cancelButtonRef: Signal<ElementRef | undefined> = viewChild('cancelButton');

  public sanitizedTranslationParams: TranslationParams | undefined;

  public buttonsVisibility = {
    showOkButton: false,
    showYesButton: false,
    showNoButton: false,
    showCancelButton: false,
    showNextButton: false
  };

  constructor(private bsModalRef: BsModalRef) {}

  public ngOnInit(): void {
    this.sanitizedTranslationParams = this.escapeTranslationParams
      ? HtmlUtils.sanitizeTranslationParams(this.translationParams)
      : this.translationParams;

    if (this.buttonFlags.indexOf(AlertButton.OK) !== -1) {
      this.buttonsVisibility.showOkButton = true;
    }
    if (this.buttonFlags.indexOf(AlertButton.YES) !== -1) {
      this.buttonsVisibility.showYesButton = true;
    }
    if (this.buttonFlags.indexOf(AlertButton.NO) !== -1) {
      this.buttonsVisibility.showNoButton = true;
    }
    if (this.buttonFlags.indexOf(AlertButton.CANCEL) !== -1) {
      this.buttonsVisibility.showCancelButton = true;
    }
    if (this.buttonFlags.indexOf(AlertButton.NEXT) !== -1) {
      this.buttonsVisibility.showNextButton = true;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.focus();
    }, 0);
  }

  ngOnDestroy(): void {
    this.bsModalRef.hide();
    this.finish.emit(AlertButton.CANCEL);
  }

  public ok(): void {
    this.bsModalRef.hide();
    this.finish.emit(AlertButton.OK);
  }

  public yes(): void {
    this.bsModalRef.hide();
    this.finish.emit(AlertButton.YES);
  }

  public no(): void {
    this.bsModalRef.hide();
    this.finish.emit(AlertButton.NO);
  }

  public cancel(): void {
    this.bsModalRef.hide();
    this.finish.emit(AlertButton.CANCEL);
  }

  public next(): void {
    this.bsModalRef.hide();
    this.finish.emit(AlertButton.NEXT);
  }

  public focus(): void {
    if (this.buttonsVisibility.showOkButton) {
      this.okButtonRef()?.nativeElement.focus();
    } else if (this.buttonsVisibility.showYesButton) {
      this.yesButtonRef()?.nativeElement.focus();
    } else if (this.buttonsVisibility.showNoButton) {
      this.noButtonRef()?.nativeElement.focus();
    } else if (this.buttonsVisibility.showCancelButton) {
      this.cancelButtonRef()?.nativeElement.focus();
    }
  }
}
